enum CalendarDisplay {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month'
}

export default CalendarDisplay;
